import CryptoJS from 'crypto-js';

// AES-128-ECB 要求密钥为16位（128位）
const SECRET_KEY = CryptoJS.enc.Utf8.parse('NxL4KL9pXB6qLVVw'); // 必须16位，与后端一致

/**
 * AES-128-ECB 加密
 * @param {string} data 待加密字符串
 * @returns {string} 加密结果（Base64）
 */
export function aesEncryptECB(data) {
  if (!data) return '';
  try {
    const srcs = CryptoJS.enc.Utf8.parse(data);
    const encrypted = CryptoJS.AES.encrypt(srcs, SECRET_KEY, {
      mode: CryptoJS.mode.ECB, // ECB模式
      padding: CryptoJS.pad.Pkcs7 // 后端若用Pkcs5，此处仍填Pkcs7（CryptoJS中Pkcs7兼容Pkcs5）
    });
    return encrypted.toString(); // 直接返回Base64结果
  } catch (error) {
    console.error('AES-128-ECB加密失败:', error);
    return '';
  }
}

/**
 * AES-128-ECB 解密
 * @param {string} encryptedData 加密后的Base64字符串
 * @returns {string} 解密结果
 */
export function aesDecryptECB(encryptedData) {
  if (!encryptedData) return '';
  try {
    const decrypt = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypt.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('AES-128-ECB解密失败:', error);
    return '';
  }
}